import { useFormikContext } from 'formik';
import useDebounce from '@forvalter/utils/useDebounce';

import type { KostnadskjemaUserInput } from '@klp/prosjekt/services/types';

/**
 * Builds the payload for calculate and save endpoints.
 * Backend now calculates delsummer[].kostnad from kostnadslinjer automatically.
 */
export const useCalculateKalkylePayload = (): KostnadskjemaUserInput => {
    const { values } = useFormikContext<KostnadskjemaUserInput>();
    const { debouncedValue } = useDebounce(values, 1000);

    const {
        id,
        prosjektId,
        prosessInstansId,
        prosjektArealM2,
        leieobjektArealM2,
        kontraktsleiePerM2,
        leieperiode,
        kostnadslinjer,
        risikotilleggSats,
        prosjektlederSats,
        avkastningskrav,
        inflasjon,
        terminerPerAar,
        grunnleiePerM2,
        delsummer,
    } = debouncedValue;

    return {
        id,
        prosjektId,
        prosessInstansId,
        prosjektArealM2: Number(prosjektArealM2),
        leieobjektArealM2: Number(leieobjektArealM2),
        kontraktsleiePerM2: Number(kontraktsleiePerM2),
        leieperiode: Number(leieperiode),
        kostnadslinjer:
            kostnadslinjer?.filter((line) => line.kostnadstype?.id) ?? [],
        risikotilleggSats: Number(risikotilleggSats),
        prosjektlederSats: Number(prosjektlederSats),
        avkastningskrav: Number(avkastningskrav),
        inflasjon: Number(inflasjon),
        terminerPerAar: Number(terminerPerAar),
        grunnleiePerM2: Number(grunnleiePerM2),
        delsummer,
    };
};
